import axios from 'axios';

const getAllCommitteesLegislatorIsAssociatedWith = async ({legislatorId, sessionId}) => {
    const response = await axios.get(`${process.env.REACT_APP_LAWS_BACKEND_HOST}/committees/v1/memberships/findByLegislatorIdAndSessionIdOrLegislatureId?legislatorId=${legislatorId}`);
    return response.data;
};

export { getAllCommitteesLegislatorIsAssociatedWith };